/**
 * 支付数据汇总信息
 */
import React from 'react';

import { Row, Col, DatePicker, Button,Select } from 'antd';

import PageLayout from '../../ui/PageLayout';

import messager from '../../ui/messager';

import http from '../../../axios/http';
import Loading from '../../ui/Loading';

class PayStatisticsDayIndex extends React.Component {

    columns = [{
        title: '日期',
        dataIndex: 'date',
        width: '10%',
    }, {
        title: '总账单数量',
        dataIndex: 'orderCount',
        width: '10%',
    }, {
        title: '退款账单数',
        dataIndex: 'refundCount',
        width: '10%',
    }, {
        title: '支付账单总额',
        dataIndex: 'totalAmount',
        width: '10%',
    }, {
        title: '退款总额',
        dataIndex: 'refundAmount',
        width: '10%',
    }, {
        title: '净收入总额',
        dataIndex: 'revenueAmount',
        width: '10%',
    }];

    state = {
        loadData: '',
        queryData: {
        },
        loadingVisible: false,

    };

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    //导出
    download = () => {
        let queryData = this.state.queryData;
        if (queryData.startDate == null || queryData.startDate === "" || queryData.endDate == null || queryData.endDate === "") {
            messager.notify("导出时需选择时间段！", null, "warning");
            return;
        }
        this.setState({ loadingVisible: true });
        queryData.pageNumber = 1;
        queryData.pageSize = 5000;
        http.download({
            url: '/payStatisticsDay/download',
            data: queryData,     //最多导出5000条数据
            fileName: queryData.startDate + "~" + queryData.endDate + "支付统计.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
        messager.notify("只会根据查询的时间段导出已经打印的数据！");
    }

    //生成今日的统计汇总
    create = () => {
        messager.confirm("是否生成昨日的统计汇总，如果已经生成了将会覆盖已生成的数据？", () => {
            http.post({
                url: '/payStatisticsDay/generate',
                success: (res) => {
                    messager.notify("生成汇总数据成功！");
                    this.state.loadData(this.state.queryData);
                }
            });
        });
    }

    onChange = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <DatePicker.RangePicker style={{margin: '10px 30px 0 0' }}
                                    onChange={this.rangePickerChange} />
                                <Select defaultValue={"all"} placeholder="全部" allowClear={true} style={{ width: '150px', margin: '10px 30px 0 0' }} onChange={this.onChange.bind(this, "type")} >
                                    <Select.Option key="all">全部</Select.Option>
                                    <Select.Option key="time_park_fee">停车费</Select.Option>
                                    <Select.Option key="vehicle_check_fee">车辆检测费</Select.Option>
                                </Select>
                                <Button type="primary" onClick={this.download} style={{ "float": "right", margin: '0 10px' }}>导出</Button>
                                {/* <Button type="primary" onClick={this.create} style={{ "float": "right" }}>创建</Button> */}
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/payStatisticsDay/query/page"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <Loading visible={this.state.loadingVisible} message="正在导出，请稍候..." />

            </div>
        )
    }
}

export default PayStatisticsDayIndex;